// Brand configuration - Switch between DPG and Fidost
// Set to true to show Fidost branding, false for DPG branding
export const USE_FIDOST_BRANDING = true;

export const BRAND_CONFIG = {
  name: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG Finance',
  tagline: USE_FIDOST_BRANDING ? 'Digital Finance Solutions' : 'Digital Payment Guarantee',
  logo: USE_FIDOST_BRANDING ? '/fidost_logo_beyaz.png' : '/logo.svg',
  logoWhite: USE_FIDOST_BRANDING ? '/fidost_logo.png' : '/logo.svg',
  appName: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG Finance',
  favicon: USE_FIDOST_BRANDING ? '/fidost_logo.png' : '/favicon.ico',
  shortName: USE_FIDOST_BRANDING ? 'Fidost' : 'DPG',
};

